import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { kyosaimypagePageMeta, kyosaimypageSchema } from 'components/common/schema'
import Template from 'components/cases/kyosaimypage'

const Kyosaimypage: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...kyosaimypagePageMeta} />
      <JsonLd data={kyosaimypageSchema} />
      <Template />
    </>
  )
}

export default Kyosaimypage
